import Snackbar from '@mui/material/Snackbar';
import { Alert } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const Toast = ({ open, severity, toastMsg, handleClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert severity={severity} icon={severity === "error" ? <ErrorOutlineIcon fontSize="inherit" /> : <CheckIcon fontSize="inherit" />}>
        {toastMsg}
      </Alert>
    </Snackbar>
  );
};

export default Toast;